// extracted by mini-css-extract-plugin
export var direction = "direction__kH_p";